import { userIdToAri } from '@townsquare/ari-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import navigationCustomisationQuery, {
	type navigationCustomisationQuery as navigationCustomisationQueryType,
} from '../components/sidebar/CustomisableSidebar/__generated__/navigationCustomisationQuery.graphql';
import { getCustomisationEntityAri } from '../util';

export const sidebarContentResource = createRelayResource<navigationCustomisationQueryType>({
	/**
	 * Allow cache to live for 30 minutes during a single SPA session
	 * This is to avoid the sidebar flickering because queryRef is null in-between re-renders / SPA navigations
	 *
	 * Once 30 mins is up, the sidebar will flicker once and be back to normal again.
	 * This is a compromise.
	 */
	maxAge: 60_000 * 30,
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const workspace = context.workspace;
		const entityAri = getCustomisationEntityAri(workspace?.cloudId, workspace?.activationId);

		// Require valid entityAri, otherwise we abort and disable sidebar customisation
		const isSidebarCustomisationEnabled = Boolean(entityAri);

		return {
			environment: getAggRelayEnvironment(),
			query: navigationCustomisationQuery,
			variables: {
				isEnabled: isSidebarCustomisationEnabled,
				entityAri: entityAri,
				ownerAri: userIdToAri(context.user.accountId),
			},
		};
	},
});
